import React from "react";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import "./GetHelpfulFeedback.css";
import Help from "../../Components/HeroSection/assets/Help.jpg";
import { Link } from "react-router-dom";

const GetHelpfulFeedback = () => {
  return (
    <div className="card card-one-1 margin refund-policy-wrapper">
      <Navbar />
      <div className="refund-static-content">
        {/* Blog Heading */}
        <div className="static-header">
          <h1 className="container">How to Give and Get Helpful Feedback on UpskillMeet</h1>
        </div>

        {/* Blog Content */}
        <div className="container mt-4 blog-detail-wrapper">
          <img
            src={Help}
            alt="How to Give and Get Helpful Feedback"
            className="blog-detail-image"
          />

          <p className="blog-meta">
            <strong>Meta Title:</strong> Giving and Receiving Feedback on UpskillMeet Sessions
            <br />
            <strong>Meta Description:</strong> Learn how to give and receive session feedback that actually helps. Build trust, improve future bookings, and grow your presence on UpskillMeet.
          </p>

          <div className="blog-detail-content">
            <p>
              Feedback is one of the most important parts of the UpskillMeet experience. 
              It helps experts improve. It helps explorers make better choices. 
              And it helps the whole platform grow in quality and trust. 
              Here’s how to give and receive feedback that’s clear, helpful, and respectful.
            </p>

            <h2>Why Feedback Matters</h2>
            <p>On UpskillMeet, every session has a feedback form.</p>
            <ul>
              <li>Explorers can share what worked well and what didn’t.</li>
              <li>Experts can understand how to improve their delivery.</li>
              <li>Honest feedback builds trust and shows professionalism.</li>
            </ul>
            <p>
              It’s not just about stars or ratings. It’s about communication and growth.
            </p>

            <h2>How Explorers Can Give Helpful Feedback</h2>
            <p>After your session ends:</p>
            <ul>
              <li>You’ll receive a link by email and see a feedback form in <em>MySpace &gt; Bookings &gt; Completed</em>.</li>
            </ul>
            <p><strong>What makes feedback helpful?</strong></p>
            <ul>
              <li>Be specific: Mention what you liked or what could be better.</li>
              <li>Stay respectful: Focus on the session, not the person.</li>
              <li>Be honest: Your experience matters, share it clearly.</li>
            </ul>
            <p><strong>Examples:</strong></p>
            <ul>
              <li>"The expert explained the topic with real life examples that helped me understand better."</li>
              <li>"I wish the session had more time for questions."</li>
            </ul>
            <p>
              Your feedback helps other users decide who to book and gives experts a chance to grow.
            </p>

            <h2>How Experts Can Use Feedback to Improve</h2>
            <p>Experts also get feedback after every session:</p>
            <ul>
              <li>You’ll receive it via email</li>
              <li>It will be visible in <em>MySpace &gt; Bookings &gt; Completed</em></li>
            </ul>
            <p><strong>Don’t just read it—use it.</strong></p>
            <ul>
              <li>Look for patterns: Do multiple explorers mention the same issue?</li>
              <li>Apply changes: Tweak how you explain, structure, or manage your sessions.</li>
              <li>Keep improving: Even great sessions can get better with feedback.</li>
            </ul>
            <p>
              Also, if you get great feedback, turn it into a testimonial post. 
              This builds trust and shows others what you offer.
            </p>

            <h2>Can Experts Give Feedback Too?</h2>
            <p>Yes. Experts also receive a form after the session to give feedback on the explorer.</p>
            <p><strong>Why this matters:</strong></p>
            <ul>
              <li>It encourages mutual respect</li>
              <li>It helps the platform flag any issues early</li>
            </ul>
            <p>Keep your comments focused and useful.</p>

            <h2>Final Tip: Make Feedback a Habit</h2>
            <p>
              Feedback isn’t extra work it’s part of the UpskillMeet experience.
            </p>
            <ul>
              <li>Take a minute after each session to complete the form</li>
              <li>Use what you learn to refine your sessions or booking choices</li>
            </ul>
            <p>
              Helping each other grow is how we all build a better skill marketplace.
            </p>
            <p><strong>Log in to leave feedback </strong></p>

            <h2>Related Reads:</h2>
            <ul>
              <li>
                <Link to="/blog/mistakes-experts-make">
                  Top Mistakes Experts Make on UpskillMeet and How to Avoid Them
                </Link>
              </li>
              <li>
                <Link to="/blog/profile-that-gets-bookings">
                  How to Build a Profile That Gets Bookings
                </Link>
              </li>
              <li>
                <Link to="/blog/what-to-post">
                  What to Post on UpskillMeet
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GetHelpfulFeedback;
